

const djangoJson = [

    {
        "id": 1,
      
        "html_title": "intro",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What is Django?",
            "bootstrap_title_desc": "Django is a high-level Python web framework that allows rapid development of secure and maintainable websites. It follows the Model-View-Template (MVT) architecture and comes with built-in features like authentication, admin panel, and ORM (Object-Relational Mapping) for database handling."
          },
      
          {
            "bootstrap_title_heading": "Installing Django",
            "bootstrap_title_desc": "To install Django, ensure you have Python installed, then run:\n\n```\npip install django\n```\n\nYou can verify the installation with:\n\n```\ndjango-admin --version\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating a Django Project",
            "bootstrap_title_desc": "To create a new Django project, run:\n\n```\ndjango-admin startproject myproject\n```\n\nNavigate to the project directory and start the development server:\n\n```\ncd myproject\npython manage.py runserver\n```\n\nYou should see the Django welcome page at http://127.0.0.1:8000/"
          }
        ],
      
        "coursename": "Django Intro (Day-1)"
      },

      {
        "id": 2,
      
        "html_title": "django-project-Structure-and-app-creation",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "Understanding Django Project Structure",
            "bootstrap_title_desc": "After creating a Django project, you'll see the following files and folders:\n\n- `manage.py` - A command-line utility for managing the project.\n- `<project_name>/` - A folder containing project settings and configurations.\n  - `__init__.py` - Marks the directory as a Python package.\n  - `settings.py` - Contains all the project settings.\n  - `urls.py` - Defines URL routing for the project.\n  - `wsgi.py` - Entry point for WSGI servers.\n  - `asgi.py` - Entry point for ASGI servers."
          },
      
          {
            "bootstrap_title_heading": "Creating a Django App",
            "bootstrap_title_desc": "Django projects can contain multiple apps. To create an app, navigate to your project directory and run:\n\n```\npython manage.py startapp myapp\n```\n\nThis creates a folder `myapp/` with the following structure:\n\n- `models.py` - Defines the database structure.\n- `views.py` - Contains logic to handle requests and responses.\n- `urls.py` - Defines URLs specific to this app.\n- `templates/` - Contains HTML templates for rendering views.\n- `static/` - Stores static files like CSS and JavaScript."
          },
      
          {
            "bootstrap_title_heading": "Registering the App in Django Settings",
            "bootstrap_title_desc": "To use the newly created app, you must register it in `settings.py`. Open `settings.py` and add the app name inside the `INSTALLED_APPS` list:\n\n```\nINSTALLED_APPS = [\n    'django.contrib.admin',\n    'django.contrib.auth',\n    'django.contrib.contenttypes',\n    'django.contrib.sessions',\n    'django.contrib.messages',\n    'django.contrib.staticfiles',\n    'myapp',  # Add your app here\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Running the Server with the New App",
            "bootstrap_title_desc": "After registering the app, restart the Django development server:\n\n```\npython manage.py runserver\n```\n\nYour Django project is now set up with a new app!"
          }
        ],
      
        "coursename": "Project Structure(Day-2)"
      },


      {
        "id": 3,
      
        "html_title": "Django URLs & Views",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "Understanding URLs in Django",
            "bootstrap_title_desc": "Django uses `urls.py` to map URLs to views. The main `urls.py` file (inside the project folder) defines project-wide URL patterns. Each app can also have its own `urls.py` for better organization."
          },
      
          {
            "bootstrap_title_heading": "Creating a Simple View",
            "bootstrap_title_desc": "A view in Django is a function that handles HTTP requests and returns responses. Open `views.py` inside your app (`myapp/views.py`) and add:\n\n```\nfrom django.http import HttpResponse\n\ndef home(request):\n    return HttpResponse(\"Hello, Django!\")\n```"
          },
      
          {
            "bootstrap_title_heading": "Defining URLs for the App",
            "bootstrap_title_desc": "Now, create a `urls.py` file inside `myapp/` (if it doesn’t exist) and add:\n\n```\nfrom django.urls import path\nfrom . import views\n\nurlpatterns = [\n    path('', views.home, name='home'),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Connecting App URLs to the Project",
            "bootstrap_title_desc": "To include the app’s URLs in the main project, open `urls.py` inside the project folder and modify it:\n\n```\nfrom django.contrib import admin\nfrom django.urls import path, include\n\nurlpatterns = [\n    path('admin/', admin.site.urls),\n    path('', include('myapp.urls')),  # Include app URLs\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Running the Server & Testing",
            "bootstrap_title_desc": "Start the server with:\n\n```\npython manage.py runserver\n```\n\nVisit `http://127.0.0.1:8000/` in your browser, and you should see `Hello, Django!` displayed."
          }
        ],
      
        "coursename": "Django URLs & Views (Day-3)"
      },

      {
        "id": 4,
      
        "html_title": "Django Templates & Static Files",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What are Django Templates?",
            "bootstrap_title_desc": "Django templates are used to separate HTML structure from Python logic. Templates allow dynamic content rendering and support template tags like `{% for %}` and `{% if %}`."
          },
      
          {
            "bootstrap_title_heading": "Creating a Templates Folder",
            "bootstrap_title_desc": "Inside your app folder (`myapp/`), create a `templates/` folder and then create another folder with your app name inside it (`templates/myapp/`). This is where HTML files will be stored.\n\n```\nmyapp/\n ├── templates/\n │    ├── myapp/\n │    │    ├── home.html\n```"
          },
      
          {
            "bootstrap_title_heading": "Writing a Basic Template",
            "bootstrap_title_desc": "Create `home.html` inside `templates/myapp/` and add:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>My Django App</title>\n</head>\n<body>\n    <h1>Welcome to Django Templates</h1>\n</body>\n</html>\n```"
          },
      
          {
            "bootstrap_title_heading": "Rendering Templates in Views",
            "bootstrap_title_desc": "Modify `views.py` to render the template instead of returning plain text:\n\n```\nfrom django.shortcuts import render\n\ndef home(request):\n    return render(request, 'myapp/home.html')\n```"
          },
      
          {
            "bootstrap_title_heading": "Configuring Templates in Settings",
            "bootstrap_title_desc": "Ensure Django knows where to find templates. Open `settings.py` and check the `TEMPLATES` setting:\n\n```\n'DIRS': [\n    BASE_DIR / 'templates',\n],\n```"
          },
      
          {
            "bootstrap_title_heading": "Adding Static Files (CSS, JS, Images)",
            "bootstrap_title_desc": "Create a `static/` folder inside your app:\n\n```\nmyapp/\n ├── static/\n │    ├── myapp/\n │    │    ├── style.css\n```\n\nWrite some CSS in `style.css`:\n\n```\nh1 {\n    color: blue;\n}\n```"
          },
      
          {
            "bootstrap_title_heading": "Using Static Files in Templates",
            "bootstrap_title_desc": "Modify `home.html` to include the CSS file:\n\n```\n{% load static %}\n<!DOCTYPE html>\n<html>\n<head>\n    <title>My Django App</title>\n    <link rel='stylesheet' href='{% static \"myapp/style.css\" %}'>\n</head>\n<body>\n    <h1>Welcome to Django Templates</h1>\n</body>\n</html>\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing the Template",
            "bootstrap_title_desc": "Run the server again and visit `http://127.0.0.1:8000/`. Your Django app should now display a styled page using templates and static files!"
          }
        ],
      
        "coursename": "Templates Files (Day-4)"
      },


      {
        "id": 6,
      
        "html_title": "Django with MongoDB Setup",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "Installing MongoDB and Djongo",
            "bootstrap_title_desc": "First, ensure that MongoDB is installed and running on your system. Then, install the required package:\n\n```\npip install djongo\n```"
          },
      
          {
            "bootstrap_title_heading": "Configuring Django to Use MongoDB",
            "bootstrap_title_desc": "Open `settings.py` and modify the `DATABASES` configuration:\n\n```\nDATABASES = {\n    'default': {\n        'ENGINE': 'djongo',\n        'NAME': 'mydatabase',  # Change this to your database name\n        'CLIENT': {\n            'host': 'mongodb://localhost:27017',\n        }\n    }\n}\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating a Model for MongoDB",
            "bootstrap_title_desc": "In `models.py`, define a model as usual:\n\n```\nfrom djongo import models\n\nclass Student(models.Model):\n    name = models.CharField(max_length=100)\n    age = models.IntegerField()\n    email = models.EmailField()\n    created_at = models.DateTimeField(auto_now_add=True)\n\n    def __str__(self):\n        return self.name\n```"
          },
      
          {
            "bootstrap_title_heading": "Applying Migrations for MongoDB",
            "bootstrap_title_desc": "Since MongoDB is schema-less, migrations work differently. Run:\n\n```\npython manage.py makemigrations\npython manage.py migrate --fake-initial\n```"
          },
      
          {
            "bootstrap_title_heading": "Registering the Model in Admin Panel",
            "bootstrap_title_desc": "Open `admin.py` and register your model:\n\n```\nfrom django.contrib import admin\nfrom .models import Student\n\nadmin.site.register(Student)\n```"
          },
      
          {
            "bootstrap_title_heading": "Running the Server & Testing",
            "bootstrap_title_desc": "Start MongoDB and Django’s development server:\n\n```\npython manage.py runserver\n```\n\nNow, visit `http://127.0.0.1:8000/admin/` and add student records to see them stored in MongoDB!"
          }
        ],
      
        "coursename": "MongoDB Setup (Day-5)"
      },

      {
        "id": 7,
      
        "html_title": "Django MongoDB CRUD Operations",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "Create a Model",
            "bootstrap_title_desc": "Open `models.py` and define a model for MongoDB:\n\n```\nfrom djongo import models\n\nclass Student(models.Model):\n    name = models.CharField(max_length=100)\n    age = models.IntegerField()\n    email = models.EmailField()\n    created_at = models.DateTimeField(auto_now_add=True)\n\n    def __str__(self):\n        return self.name\n```"
          },
      
          {
            "bootstrap_title_heading": "Setting Up URLs",
            "bootstrap_title_desc": "Open `urls.py` inside your app and add CRUD routes:\n\n```\nfrom django.urls import path\nfrom . import views\n\nurlpatterns = [\n    path('students/', views.student_list, name='student_list'),\n    path('students/create/', views.create_student, name='create_student'),\n    path('students/update/<str:id>/', views.update_student, name='update_student'),\n    path('students/delete/<str:id>/', views.delete_student, name='delete_student'),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating CRUD Views",
            "bootstrap_title_desc": "Modify `views.py` to handle CRUD operations:\n\n```\nfrom django.shortcuts import render, redirect\nfrom django.http import JsonResponse\nfrom .models import Student\n\n# Read (Get all students)\ndef student_list(request):\n    students = Student.objects.all()\n    data = [{\"id\": str(student.id), \"name\": student.name, \"age\": student.age, \"email\": student.email} for student in students]\n    return JsonResponse({\"students\": data})\n\n# Create (Add new student)\ndef create_student(request):\n    if request.method == 'POST':\n        name = request.POST['name']\n        age = request.POST['age']\n        email = request.POST['email']\n        Student.objects.create(name=name, age=age, email=email)\n    return redirect('/students/')\n\n# Update (Edit student details)\ndef update_student(request, id):\n    student = Student.objects.get(id=id)\n    if request.method == 'POST':\n        student.name = request.POST['name']\n        student.age = request.POST['age']\n        student.email = request.POST['email']\n        student.save()\n    return redirect('/students/')\n\n# Delete (Remove student)\ndef delete_student(request, id):\n    student = Student.objects.get(id=id)\n    student.delete()\n    return redirect('/students/')\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating a Simple Form for CRUD",
            "bootstrap_title_desc": "Inside `templates/myapp/`, create `student_form.html`:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>Student Form</title>\n</head>\n<body>\n    <h2>Add Student</h2>\n    <form method='POST'>\n        {% csrf_token %}\n        <input type='text' name='name' placeholder='Name'><br>\n        <input type='number' name='age' placeholder='Age'><br>\n        <input type='email' name='email' placeholder='Email'><br>\n        <button type='submit'>Submit</button>\n    </form>\n</body>\n</html>\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing CRUD Operations",
            "bootstrap_title_desc": "1. Run your server:\n\n```\npython manage.py runserver\n```\n\n2. Use `http://127.0.0.1:8000/students/` to **view** all students.\n\n3. Use `http://127.0.0.1:8000/students/create/` with a POST request to **add** a student.\n\n4. Use `http://127.0.0.1:8000/students/update/<id>/` to **edit** student details.\n\n5. Use `http://127.0.0.1:8000/students/delete/<id>/` to **remove** a student."
          }
        ],
      
        "coursename": "CRUD Operations (Day-6)"
      },


      {
        "id": 8,
      
        "html_title": "Django Forms & Validations with MongoDB",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What are Django Forms?",
            "bootstrap_title_desc": "Django Forms provide an easy way to handle user input, including validation and rendering HTML forms dynamically."
          },
      
          {
            "bootstrap_title_heading": "Creating a Django Form for Students",
            "bootstrap_title_desc": "Create a new file `forms.py` inside your app and define a form:\n\n```\nfrom django import forms\nfrom .models import Student\n\nclass StudentForm(forms.ModelForm):\n    class Meta:\n        model = Student\n        fields = ['name', 'age', 'email']\n```"
          },
      
          {
            "bootstrap_title_heading": "Updating Views to Use Forms",
            "bootstrap_title_desc": "Modify `views.py` to use the form for creating and updating students:\n\n```\nfrom django.shortcuts import render, redirect\nfrom .models import Student\nfrom .forms import StudentForm\n\n# Create Student with Form\ndef create_student(request):\n    if request.method == 'POST':\n        form = StudentForm(request.POST)\n        if form.is_valid():\n            form.save()\n            return redirect('/students/')\n    else:\n        form = StudentForm()\n    return render(request, 'myapp/student_form.html', {'form': form})\n\n# Update Student with Form\ndef update_student(request, id):\n    student = Student.objects.get(id=id)\n    if request.method == 'POST':\n        form = StudentForm(request.POST, instance=student)\n        if form.is_valid():\n            form.save()\n            return redirect('/students/')\n    else:\n        form = StudentForm(instance=student)\n    return render(request, 'myapp/student_form.html', {'form': form})\n```"
          },
      
          {
            "bootstrap_title_heading": "Updating the Template for Forms",
            "bootstrap_title_desc": "Modify `student_form.html` to use Django's form rendering:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>Student Form</title>\n</head>\n<body>\n    <h2>Student Form</h2>\n    <form method='POST'>\n        {% csrf_token %}\n        {{ form.as_p }}\n        <button type='submit'>Submit</button>\n    </form>\n</body>\n</html>\n```"
          },
      
          {
            "bootstrap_title_heading": "Adding Validation to Forms",
            "bootstrap_title_desc": "Modify `forms.py` to include custom validation for the email field:\n\n```\nfrom django import forms\nfrom .models import Student\n\nclass StudentForm(forms.ModelForm):\n    class Meta:\n        model = Student\n        fields = ['name', 'age', 'email']\n\n    def clean_email(self):\n        email = self.cleaned_data.get('email')\n        if not email.endswith('@example.com'):\n            raise forms.ValidationError('Only emails from example.com are allowed.')\n        return email\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing Forms and Validations",
            "bootstrap_title_desc": "1. Run the server:\n\n```\npython manage.py runserver\n```\n\n2. Go to `http://127.0.0.1:8000/students/create/` and try submitting a student with an invalid email.\n\n3. Update a student at `http://127.0.0.1:8000/students/update/<id>/` and see the validation in action!"
          }
        ],
      
        "coursename": "Forms & Validations(Day-7)"
      }
      ,

      {
        "id": 9,
      
        "html_title": "Django Class-Based Views with MongoDB",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What are Class-Based Views (CBVs)?",
            "bootstrap_title_desc": "Class-Based Views (CBVs) provide a more structured and reusable way to handle views in Django. They help reduce repetitive code compared to function-based views (FBVs)."
          },
      
          {
            "bootstrap_title_heading": "Converting CRUD Operations to CBVs",
            "bootstrap_title_desc": "Modify `views.py` to use Django's built-in CBVs for CRUD operations:\n\n```\nfrom django.views.generic import ListView, CreateView, UpdateView, DeleteView\nfrom django.urls import reverse_lazy\nfrom .models import Student\n\n# List Students\nclass StudentListView(ListView):\n    model = Student\n    template_name = 'myapp/student_list.html'\n    context_object_name = 'students'\n\n# Create Student\nclass StudentCreateView(CreateView):\n    model = Student\n    fields = ['name', 'age', 'email']\n    template_name = 'myapp/student_form.html'\n    success_url = reverse_lazy('student_list')\n\n# Update Student\nclass StudentUpdateView(UpdateView):\n    model = Student\n    fields = ['name', 'age', 'email']\n    template_name = 'myapp/student_form.html'\n    success_url = reverse_lazy('student_list')\n\n# Delete Student\nclass StudentDeleteView(DeleteView):\n    model = Student\n    template_name = 'myapp/student_confirm_delete.html'\n    success_url = reverse_lazy('student_list')\n```"
          },
      
          {
            "bootstrap_title_heading": "Updating URLs for CBVs",
            "bootstrap_title_desc": "Modify `urls.py` to use CBVs:\n\n```\nfrom django.urls import path\nfrom .views import StudentListView, StudentCreateView, StudentUpdateView, StudentDeleteView\n\nurlpatterns = [\n    path('students/', StudentListView.as_view(), name='student_list'),\n    path('students/create/', StudentCreateView.as_view(), name='create_student'),\n    path('students/update/<str:pk>/', StudentUpdateView.as_view(), name='update_student'),\n    path('students/delete/<str:pk>/', StudentDeleteView.as_view(), name='delete_student'),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Updating Templates for CBVs",
            "bootstrap_title_desc": "Modify `student_list.html` to display students:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>Student List</title>\n</head>\n<body>\n    <h2>Students</h2>\n    <a href=\"{% url 'create_student' %}\">Add Student</a>\n    <ul>\n        {% for student in students %}\n            <li>{{ student.name }} - {{ student.age }} - {{ student.email }}\n                <a href=\"{% url 'update_student' student.id %}\">Edit</a>\n                <a href=\"{% url 'delete_student' student.id %}\">Delete</a>\n            </li>\n        {% endfor %}\n    </ul>\n</body>\n</html>\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing CBVs with MongoDB",
            "bootstrap_title_desc": "1. Start the Django server:\n\n```\npython manage.py runserver\n```\n\n2. Open `http://127.0.0.1:8000/students/` to view the student list.\n\n3. Navigate to `http://127.0.0.1:8000/students/create/` to add a new student.\n\n4. Use `http://127.0.0.1:8000/students/update/<id>/` to update a student.\n\n5. Use `http://127.0.0.1:8000/students/delete/<id>/` to delete a student."
          }
        ],
      
        "coursename": "Class-Based Views (Day-8)"
      },


      {
        "id": 10,
      
        "html_title": "Django Authentication with MongoDB",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What is Django Authentication?",
            "bootstrap_title_desc": "Django provides a built-in authentication system to handle user login, logout, and signup securely."
          },
      
          {
            "bootstrap_title_heading": "Setting Up User Model",
            "bootstrap_title_desc": "Modify `models.py` to create a custom user model (optional for MongoDB):\n\n```\nfrom djongo import models\nfrom django.contrib.auth.models import AbstractUser\n\nclass CustomUser(AbstractUser):\n    phone = models.CharField(max_length=15, unique=True, null=True, blank=True)\n\n    def __str__(self):\n        return self.username\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating User Forms",
            "bootstrap_title_desc": "Create a `forms.py` file and add forms for signup and login:\n\n```\nfrom django import forms\nfrom django.contrib.auth.forms import UserCreationForm, AuthenticationForm\nfrom .models import CustomUser\n\nclass SignupForm(UserCreationForm):\n    phone = forms.CharField(required=True)\n\n    class Meta:\n        model = CustomUser\n        fields = ['username', 'email', 'phone', 'password1', 'password2']\n\nclass LoginForm(AuthenticationForm):\n    pass\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating Authentication Views",
            "bootstrap_title_desc": "Modify `views.py` to handle user authentication:\n\n```\nfrom django.shortcuts import render, redirect\nfrom django.contrib.auth import login, logout, authenticate\nfrom .forms import SignupForm, LoginForm\n\n# User Signup\ndef signup_view(request):\n    if request.method == 'POST':\n        form = SignupForm(request.POST)\n        if form.is_valid():\n            user = form.save()\n            login(request, user)\n            return redirect('/dashboard/')\n    else:\n        form = SignupForm()\n    return render(request, 'auth/signup.html', {'form': form})\n\n# User Login\ndef login_view(request):\n    if request.method == 'POST':\n        form = LoginForm(data=request.POST)\n        if form.is_valid():\n            user = form.get_user()\n            login(request, user)\n            return redirect('/dashboard/')\n    else:\n        form = LoginForm()\n    return render(request, 'auth/login.html', {'form': form})\n\n# User Logout\ndef logout_view(request):\n    logout(request)\n    return redirect('/login/')\n```"
          },
      
          {
            "bootstrap_title_heading": "Updating URLs for Authentication",
            "bootstrap_title_desc": "Modify `urls.py` to add authentication routes:\n\n```\nfrom django.urls import path\nfrom .views import signup_view, login_view, logout_view\n\nurlpatterns = [\n    path('signup/', signup_view, name='signup'),\n    path('login/', login_view, name='login'),\n    path('logout/', logout_view, name='logout'),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating Authentication Templates",
            "bootstrap_title_desc": "Create `templates/auth/signup.html`:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>Signup</title>\n</head>\n<body>\n    <h2>Signup</h2>\n    <form method='POST'>\n        {% csrf_token %}\n        {{ form.as_p }}\n        <button type='submit'>Sign Up</button>\n    </form>\n</body>\n</html>\n```\n\nCreate `templates/auth/login.html`:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>Login</title>\n</head>\n<body>\n    <h2>Login</h2>\n    <form method='POST'>\n        {% csrf_token %}\n        {{ form.as_p }}\n        <button type='submit'>Login</button>\n    </form>\n</body>\n</html>\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing Authentication",
            "bootstrap_title_desc": "1. Run the server:\n\n```\npython manage.py runserver\n```\n\n2. Go to `http://127.0.0.1:8000/signup/` to **register a new user**.\n\n3. Go to `http://127.0.0.1:8000/login/` to **log in**.\n\n4. Go to `http://127.0.0.1:8000/logout/` to **log out**."
          }
        ],
      
        "coursename": "Django Authentication(Day-9)"
      },

      {
        "id": 11,
      
        "html_title": "Django User Roles & Permissions with MongoDB",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What are User Roles & Permissions?",
            "bootstrap_title_desc": "User roles and permissions in Django allow you to control which users can perform certain actions, such as viewing, editing, or deleting data."
          },
      
          {
            "bootstrap_title_heading": "Extending the User Model with Roles",
            "bootstrap_title_desc": "Modify `models.py` to add user roles:\n\n```\nfrom djongo import models\nfrom django.contrib.auth.models import AbstractUser\n\nclass CustomUser(AbstractUser):\n    ROLE_CHOICES = [\n        ('admin', 'Admin'),\n        ('staff', 'Staff'),\n        ('user', 'User'),\n    ]\n    role = models.CharField(max_length=10, choices=ROLE_CHOICES, default='user')\n\n    def __str__(self):\n        return self.username\n```"
          },
      
          {
            "bootstrap_title_heading": "Assigning Roles During Signup",
            "bootstrap_title_desc": "Modify `forms.py` to let users choose a role:\n\n```\nfrom django import forms\nfrom django.contrib.auth.forms import UserCreationForm\nfrom .models import CustomUser\n\nclass SignupForm(UserCreationForm):\n    role = forms.ChoiceField(choices=CustomUser.ROLE_CHOICES)\n\n    class Meta:\n        model = CustomUser\n        fields = ['username', 'email', 'role', 'password1', 'password2']\n```"
          },
      
          {
            "bootstrap_title_heading": "Restricting Access Based on Role",
            "bootstrap_title_desc": "Modify `views.py` to restrict views based on user role:\n\n```\nfrom django.shortcuts import render, redirect\nfrom django.contrib.auth.decorators import login_required\nfrom .models import CustomUser\n\n@login_required\ndef admin_dashboard(request):\n    if request.user.role != 'admin':\n        return redirect('/login/')\n    return render(request, 'dashboard/admin.html')\n\n@login_required\ndef staff_dashboard(request):\n    if request.user.role != 'staff':\n        return redirect('/login/')\n    return render(request, 'dashboard/staff.html')\n```"
          },
      
          {
            "bootstrap_title_heading": "Updating URLs for Role-Based Views",
            "bootstrap_title_desc": "Modify `urls.py` to add routes:\n\n```\nfrom django.urls import path\nfrom .views import admin_dashboard, staff_dashboard\n\nurlpatterns = [\n    path('admin-dashboard/', admin_dashboard, name='admin_dashboard'),\n    path('staff-dashboard/', staff_dashboard, name='staff_dashboard'),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating Dashboard Templates",
            "bootstrap_title_desc": "Create `templates/dashboard/admin.html`:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>Admin Dashboard</title>\n</head>\n<body>\n    <h2>Welcome, Admin!</h2>\n    <a href=\"/logout/\">Logout</a>\n</body>\n</html>\n```\n\nCreate `templates/dashboard/staff.html`:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>Staff Dashboard</title>\n</head>\n<body>\n    <h2>Welcome, Staff!</h2>\n    <a href=\"/logout/\">Logout</a>\n</body>\n</html>\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing Role-Based Access Control",
            "bootstrap_title_desc": "1. Run the server:\n\n```\npython manage.py runserver\n```\n\n2. Signup as an **admin** and go to `http://127.0.0.1:8000/admin-dashboard/`.\n\n3. Signup as **staff** and go to `http://127.0.0.1:8000/staff-dashboard/`.\n\n4. Try accessing a restricted page with a different role to see the redirection."
          }
        ],
      
        "coursename": " User Roles(Day-10)"
      }
      ,

      {
        "id": 12,
      
        "html_title": "Django REST Framework (DRF) – Creating APIs with MongoDB",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What is Django REST Framework (DRF)?",
            "bootstrap_title_desc": "Django REST Framework (DRF) is a powerful tool for building REST APIs in Django. It provides authentication, serialization, and viewsets to create APIs quickly."
          },
      
          {
            "bootstrap_title_heading": "Installing DRF",
            "bootstrap_title_desc": "Install DRF using pip:\n\n```\npip install djangorestframework\n```\n\nAdd `'rest_framework'` to `INSTALLED_APPS` in `settings.py`:\n\n```\nINSTALLED_APPS = [\n    'django.contrib.admin',\n    'django.contrib.auth',\n    'rest_framework',\n    'yourapp',\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating a Model for API",
            "bootstrap_title_desc": "Modify `models.py` to define a Product model:\n\n```\nfrom djongo import models\n\nclass Product(models.Model):\n    name = models.CharField(max_length=255)\n    price = models.FloatField()\n    description = models.TextField()\n\n    def __str__(self):\n        return self.name\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating a Serializer",
            "bootstrap_title_desc": "Create a `serializers.py` file to convert Django models to JSON:\n\n```\nfrom rest_framework import serializers\nfrom .models import Product\n\nclass ProductSerializer(serializers.ModelSerializer):\n    class Meta:\n        model = Product\n        fields = '__all__'\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating API Views",
            "bootstrap_title_desc": "Modify `views.py` to create API views:\n\n```\nfrom rest_framework import viewsets\nfrom .models import Product\nfrom .serializers import ProductSerializer\n\nclass ProductViewSet(viewsets.ModelViewSet):\n    queryset = Product.objects.all()\n    serializer_class = ProductSerializer\n```"
          },
      
          {
            "bootstrap_title_heading": "Setting Up API URLs",
            "bootstrap_title_desc": "Modify `urls.py` to add API routes:\n\n```\nfrom django.urls import path, include\nfrom rest_framework.routers import DefaultRouter\nfrom .views import ProductViewSet\n\nrouter = DefaultRouter()\nrouter.register(r'products', ProductViewSet)\n\nurlpatterns = [\n    path('api/', include(router.urls)),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing API Endpoints",
            "bootstrap_title_desc": "Run the server:\n\n```\npython manage.py runserver\n```\n\nTest the API using Postman or a browser:\n\n- `GET http://127.0.0.1:8000/api/products/` → Get all products\n- `POST http://127.0.0.1:8000/api/products/` → Add a new product\n- `PUT http://127.0.0.1:8000/api/products/1/` → Update product with ID 1\n- `DELETE http://127.0.0.1:8000/api/products/1/` → Delete product with ID 1"
          }
        ],
      
        "coursename": "APIs with MongoDB (Day-11)"
      },

      {
        "id": 13,
      
        "html_title": "JWT Authentication in Django REST Framework (DRF) with MongoDB",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What is JWT Authentication?",
            "bootstrap_title_desc": "JWT (JSON Web Token) is a secure method to authenticate users in APIs. It provides a token that users can use to access protected routes."
          },
      
          {
            "bootstrap_title_heading": "Installing JWT Authentication",
            "bootstrap_title_desc": "Install the required package:\n\n```\npip install djangorestframework-simplejwt\n```\n\nAdd authentication settings in `settings.py`:\n\n```\nINSTALLED_APPS = [\n    'rest_framework',\n    'rest_framework_simplejwt',\n]\n\nREST_FRAMEWORK = {\n    'DEFAULT_AUTHENTICATION_CLASSES': (\n        'rest_framework_simplejwt.authentication.JWTAuthentication',\n    ),\n}\n```"
          },
      
          {
            "bootstrap_title_heading": "Setting Up JWT URLs",
            "bootstrap_title_desc": "Modify `urls.py` to include JWT routes:\n\n```\nfrom django.urls import path\nfrom rest_framework_simplejwt.views import TokenObtainPairView, TokenRefreshView\n\nurlpatterns = [\n    path('api/token/', TokenObtainPairView.as_view(), name='token_obtain_pair'),\n    path('api/token/refresh/', TokenRefreshView.as_view(), name='token_refresh'),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing JWT Authentication",
            "bootstrap_title_desc": "Run the server and test using Postman or cURL:\n\n1. Get a token:\n\n```\nPOST http://127.0.0.1:8000/api/token/\nBody: {\n    \"username\": \"your_username\",\n    \"password\": \"your_password\"\n}\n```\n\n2. Use the token in API requests:\n\n```\nGET http://127.0.0.1:8000/api/products/\nHeaders: {\n    \"Authorization\": \"Bearer your_access_token\"\n}\n```"
          }
        ],
      
        "coursename": "JWT Authentication(Day-12)"
      },

      {
        "id": 14,
      
        "html_title": "Django File Upload with MongoDB using DRF",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What is File Upload in Django?",
            "bootstrap_title_desc": "File upload allows users to upload images, PDFs, and other files to the server and store them in a database or file system."
          },
      
          {
            "bootstrap_title_heading": "Installing Pillow (for Image Processing)",
            "bootstrap_title_desc": "Install Pillow, a required package for handling images:\n\n```\npip install pillow\n```"
          },
      
          {
            "bootstrap_title_heading": "Updating Models for File Upload",
            "bootstrap_title_desc": "Modify `models.py` to create a File model:\n\n```\nfrom djongo import models\n\nclass UploadedFile(models.Model):\n    title = models.CharField(max_length=255)\n    file = models.FileField(upload_to='uploads/')\n\n    def __str__(self):\n        return self.title\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating Serializer for File Upload",
            "bootstrap_title_desc": "Create a `serializers.py` file for file uploads:\n\n```\nfrom rest_framework import serializers\nfrom .models import UploadedFile\n\nclass FileSerializer(serializers.ModelSerializer):\n    class Meta:\n        model = UploadedFile\n        fields = '__all__'\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating File Upload API View",
            "bootstrap_title_desc": "Modify `views.py` to handle file uploads:\n\n```\nfrom rest_framework import viewsets, parsers\nfrom .models import UploadedFile\nfrom .serializers import FileSerializer\n\nclass FileUploadViewSet(viewsets.ModelViewSet):\n    queryset = UploadedFile.objects.all()\n    serializer_class = FileSerializer\n    parser_classes = [parsers.MultiPartParser, parsers.FormParser]\n```"
          },
      
          {
            "bootstrap_title_heading": "Setting Up API URLs for File Upload",
            "bootstrap_title_desc": "Modify `urls.py` to add file upload API:\n\n```\nfrom django.urls import path, include\nfrom rest_framework.routers import DefaultRouter\nfrom .views import FileUploadViewSet\n\nrouter = DefaultRouter()\nrouter.register(r'files', FileUploadViewSet)\n\nurlpatterns = [\n    path('api/', include(router.urls)),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Configuring Media Settings",
            "bootstrap_title_desc": "Modify `settings.py` to configure file storage:\n\n```\nMEDIA_URL = '/media/'\nMEDIA_ROOT = BASE_DIR / 'media'\n```\n\nModify `urls.py` to serve uploaded files:\n\n```\nfrom django.conf import settings\nfrom django.conf.urls.static import static\nurlpatterns += static(settings.MEDIA_URL, document_root=settings.MEDIA_ROOT)\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing File Upload API",
            "bootstrap_title_desc": "Run the server and test file upload using Postman:\n\n```\nPOST http://127.0.0.1:8000/api/files/\nBody: { \"title\": \"My File\", \"file\": <upload a file> }\n```\n\nCheck uploaded files in the `media/uploads/` directory."
          }
        ],
      
        "coursename": "File Upload(Day-13)"
      },


      {
        "id": 15,
      
        "html_title": "Sending Emails in Django using SMTP",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What is SMTP Email in Django?",
            "bootstrap_title_desc": "SMTP (Simple Mail Transfer Protocol) is used to send emails from a Django application. You can use services like Gmail, SendGrid, or AWS SES."
          },
      
          {
            "bootstrap_title_heading": "Configuring Django Email Settings",
            "bootstrap_title_desc": "Modify `settings.py` to configure SMTP settings (Example: Gmail SMTP):\n\n```\nEMAIL_BACKEND = 'django.core.mail.backends.smtp.EmailBackend'\nEMAIL_HOST = 'smtp.gmail.com'\nEMAIL_PORT = 587\nEMAIL_USE_TLS = True\nEMAIL_HOST_USER = 'your_email@gmail.com'\nEMAIL_HOST_PASSWORD = 'your_email_password'\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating a Function to Send Emails",
            "bootstrap_title_desc": "Modify `views.py` to create an email-sending function:\n\n```\nfrom django.core.mail import send_mail\nfrom django.http import JsonResponse\nfrom django.conf import settings\n\ndef send_email(request):\n    subject = \"Welcome to Django Email!\"\n    message = \"This is a test email sent from Django.\"\n    recipient_list = [\"recipient@example.com\"]\n    send_mail(subject, message, settings.EMAIL_HOST_USER, recipient_list)\n    return JsonResponse({\"message\": \"Email sent successfully!\"})\n```"
          },
      
          {
            "bootstrap_title_heading": "Setting Up Email URL",
            "bootstrap_title_desc": "Modify `urls.py` to add an email route:\n\n```\nfrom django.urls import path\nfrom .views import send_email\n\nurlpatterns = [\n    path('send-email/', send_email, name='send_email'),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Testing Email Sending",
            "bootstrap_title_desc": "Run the Django server and send a test email:\n\n```\nGET http://127.0.0.1:8000/send-email/\n```\n\nCheck the recipient's inbox for the test email."
          },
      
          {
            "bootstrap_title_heading": "Using HTML Templates for Emails",
            "bootstrap_title_desc": "Modify `views.py` to send an email with an HTML template:\n\n```\nfrom django.core.mail import EmailMessage\nfrom django.template.loader import render_to_string\n\ndef send_html_email(request):\n    subject = \"Welcome!\"\n    message = render_to_string('email_template.html', {'name': 'User'})\n    email = EmailMessage(subject, message, settings.EMAIL_HOST_USER, [\"recipient@example.com\"])\n    email.content_subtype = 'html'\n    email.send()\n    return JsonResponse({\"message\": \"HTML Email sent!\"})\n```"
          },
      
          {
            "bootstrap_title_heading": "Adding an HTML Email Template",
            "bootstrap_title_desc": "Create a template `templates/email_template.html`:\n\n```\n<!DOCTYPE html>\n<html>\n<head>\n    <title>Welcome Email</title>\n</head>\n<body>\n    <h2>Hello {{ name }},</h2>\n    <p>Welcome to our platform! We are excited to have you.</p>\n</body>\n</html>\n```"
          }
        ],
      
        "coursename": "Emails SMTP(Day-14)"
      },


      {
        "id": 16,
      
        "html_title": "Deploying Django on Render",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What is Render?",
            "bootstrap_title_desc": "Render is a cloud platform that allows easy deployment of web applications, including Django projects. It provides free hosting with a simple setup."
          },
      
          {
            "bootstrap_title_heading": "Installing Required Packages",
            "bootstrap_title_desc": "Install `gunicorn` and `whitenoise` for production:\n\n```\npip install gunicorn whitenoise\n```"
          },
      
          {
            "bootstrap_title_heading": "Updating Django Settings for Production",
            "bootstrap_title_desc": "Modify `settings.py`:\n\n```\nimport os\n\nDEBUG = False\nALLOWED_HOSTS = ['your-render-app.onrender.com']\n\nMIDDLEWARE = [\n    'django.middleware.security.SecurityMiddleware',\n    'whitenoise.middleware.WhiteNoiseMiddleware',  # Static files handling\n    'django.middleware.common.CommonMiddleware',\n    'django.middleware.csrf.CsrfViewMiddleware',\n    'django.middleware.clickjacking.XFrameOptionsMiddleware',\n]\n\nSTATICFILES_STORAGE = 'whitenoise.storage.CompressedManifestStaticFilesStorage'\n```"
          },
      
          {
            "bootstrap_title_heading": "Setting Up a Procfile",
            "bootstrap_title_desc": "Create a `Procfile` (no extension) in the root directory:\n\n```\nweb: gunicorn your_project.wsgi:application\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating a `requirements.txt` File",
            "bootstrap_title_desc": "Generate a `requirements.txt` file for dependencies:\n\n```\npip freeze > requirements.txt\n```"
          },
      
          {
            "bootstrap_title_heading": "Pushing Django Project to GitHub",
            "bootstrap_title_desc": "Initialize a Git repository and push the code to GitHub:\n\n```\ngit init\ngit add .\ngit commit -m \"Initial commit\"\ngit branch -M main\ngit remote add origin https://github.com/your-username/your-repo.git\ngit push -u origin main\n```"
          },
      
          {
            "bootstrap_title_heading": "Deploying to Render",
            "bootstrap_title_desc": "1. Go to [Render](https://render.com/).\n2. Click **New Web Service**.\n3. Connect your GitHub repository.\n4. Set the build command: `pip install -r requirements.txt && python manage.py migrate`\n5. Set the start command: `gunicorn your_project.wsgi`\n6. Click **Deploy** and wait for the deployment to finish."
          },
      
          {
            "bootstrap_title_heading": "Testing the Deployment",
            "bootstrap_title_desc": "Visit `https://your-render-app.onrender.com/` to check your deployed Django project."
          }
        ],
      
        "coursename": "Deploying Render(Day-15)"
      }
      ,


      {
        "id": 17,
      
        "html_title": "Integrating Razorpay Payment Gateway in Django",
      
        "bootstrap_head_desc": [
      
          {
            "bootstrap_title_heading": "What is Razorpay?",
            "bootstrap_title_desc": "Razorpay is a popular payment gateway that allows businesses to accept online payments in India. It provides APIs for seamless payment integration."
          },
      
          {
            "bootstrap_title_heading": "Installing Razorpay SDK",
            "bootstrap_title_desc": "Install the Razorpay Python package:\n\n```\npip install razorpay\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating a Razorpay Account",
            "bootstrap_title_desc": "1. Go to [Razorpay](https://razorpay.com/) and sign up.\n2. Get your **API Key** and **Secret Key** from the dashboard."
          },
      
          {
            "bootstrap_title_heading": "Adding Razorpay Configuration in Django",
            "bootstrap_title_desc": "Modify `settings.py`:\n\n```\nRAZORPAY_KEY_ID = 'your_api_key'\nRAZORPAY_KEY_SECRET = 'your_secret_key'\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating Payment Model",
            "bootstrap_title_desc": "Modify `models.py` to store payment details:\n\n```\nfrom django.db import models\n\nclass Payment(models.Model):\n    order_id = models.CharField(max_length=255)\n    payment_id = models.CharField(max_length=255, blank=True, null=True)\n    amount = models.FloatField()\n    status = models.CharField(max_length=50)\n    created_at = models.DateTimeField(auto_now_add=True)\n```"
          },
      
          {
            "bootstrap_title_heading": "Creating Razorpay Order in Django",
            "bootstrap_title_desc": "Modify `views.py`:\n\n```\nimport razorpay\nfrom django.conf import settings\nfrom django.http import JsonResponse\nfrom .models import Payment\n\ndef create_order(request):\n    client = razorpay.Client(auth=(settings.RAZORPAY_KEY_ID, settings.RAZORPAY_KEY_SECRET))\n    amount = 50000  # Amount in paise (₹500)\n    data = {\"amount\": amount, \"currency\": \"INR\", \"payment_capture\": \"1\"}\n    order = client.order.create(data)\n    Payment.objects.create(order_id=order['id'], amount=amount / 100, status='Created')\n    return JsonResponse(order)\n```"
          },
      
          {
            "bootstrap_title_heading": "Adding Payment URL in Django",
            "bootstrap_title_desc": "Modify `urls.py`:\n\n```\nfrom django.urls import path\nfrom .views import create_order\n\nurlpatterns = [\n    path('create-order/', create_order, name='create_order'),\n]\n```"
          },
      
          {
            "bootstrap_title_heading": "Frontend Integration with Razorpay",
            "bootstrap_title_desc": "Create a simple HTML page (`templates/payment.html`) to handle payments:\n\n```\n<form>\n    <script\n        src=\"https://checkout.razorpay.com/v1/checkout.js\"\n        data-key=\"your_api_key\"\n        data-amount=\"50000\"\n        data-currency=\"INR\"\n        data-order_id=\"order_ID_from_backend\"\n        data-buttontext=\"Pay Now\"\n    ></script>\n</form>\n```"
          },
      
          {
            "bootstrap_title_heading": "Handling Payment Success in Django",
            "bootstrap_title_desc": "Modify `views.py` to verify payments:\n\n```\ndef verify_payment(request):\n    client = razorpay.Client(auth=(settings.RAZORPAY_KEY_ID, settings.RAZORPAY_KEY_SECRET))\n    payment_id = request.GET.get('razorpay_payment_id')\n    order_id = request.GET.get('razorpay_order_id')\n    signature = request.GET.get('razorpay_signature')\n    \n    params_dict = {\n        'razorpay_order_id': order_id,\n        'razorpay_payment_id': payment_id,\n        'razorpay_signature': signature\n    }\n    \n    try:\n        client.utility.verify_payment_signature(params_dict)\n        Payment.objects.filter(order_id=order_id).update(payment_id=payment_id, status='Paid')\n        return JsonResponse({'message': 'Payment successful'})\n    except:\n        return JsonResponse({'message': 'Payment verification failed'}, status=400)\n```"
          },
      
          {
            "bootstrap_title_heading": "Adding Payment Verification URL",
            "bootstrap_title_desc": "Modify `urls.py`:\n\n```\nfrom .views import verify_payment\nurlpatterns += [\n    path('verify-payment/', verify_payment, name='verify_payment'),\n]\n```"
          }
        ],
      
        "coursename": "Payment Gateway(Day-16)"
      },

    
      
      
      
      
      
      
      


      
      
      
      
      


      
      
   
   
  
   
     
   
   
   ]
 export default djangoJson